import { createFileRoute, redirect } from "@tanstack/react-router";
import { ProvidersSharedPage } from "@/routes/_org/org/bu/$organizationBusinessUnitId/providers/shared/_components/providers-shared-page";

export const Route = createFileRoute("/_org/org/providers/shared/")({
  beforeLoad: ({ context }) => {
    const organizationBusinessUnitId = (
      context as { savedOrgBusinessUnit?: { id?: string } }
    ).savedOrgBusinessUnit?.id;
    if (organizationBusinessUnitId) {
      throw redirect({
        to: "/org/bu/$organizationBusinessUnitId/providers/shared",
        params: { organizationBusinessUnitId },
      });
    }
    // No org — render the shared-with-me page in place (no redirect).
  },
  component: ProvidersSharedPage,
});
